// Shared secret used for Basic auth with Cloud Functions google-apis endpoints.
// Must match the server expectation (functions/config.json codecanyon_purchase_code).

const AccessKey = '46f9f2f9-2f43-4b22-9e67-6f9d3df0ff16';

export default AccessKey;

